import { StatusBar } from "expo-status-bar";
import { Fontisto } from "@expo/vector-icons";
import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  TouchableHighlight,
  TouchableWithoutFeedback,
  TextInput,
  ScrollView,
  Alert,
  Platform,
} from "react-native";
import { theme } from "./colors";
import AsyncStorage from "@react-native-async-storage/async-storage";
const STORAGE_KEY = "@toDos";
const STORAGE_KEY_WORK_TRAVEL = "@workTravel";

export default function App() {
  const [working, setWorking] = useState(true);
  const [isModify, setIsModify] = useState(false);
  const [modifyKey, setModifyKey] = useState("");
  const [text, setText] = useState("");
  const [modifyText, setModifyText] = useState("");
  const [toDos, setToDos] = useState({});

  useEffect(() => {
    loadToDos();
    loadWorkTravel();
  }, []);
  useEffect(() => {
    saveWorkTravel();
  }, [working]);

  const saveToDos = async (toSave) => {
    await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
  };
  const saveWorkTravel = async () => {
    const isWork = working ? "working" : "travel";
    await AsyncStorage.setItem(STORAGE_KEY_WORK_TRAVEL, isWork);
  };
  const loadToDos = async () => {
    const s = await AsyncStorage.getItem(STORAGE_KEY);
    if (s) setToDos(JSON.parse(s));
  };
  const loadWorkTravel = async () => {
    const loadData = await AsyncStorage.getItem(STORAGE_KEY_WORK_TRAVEL);
    const isWork = loadData === "working" ? true : false;
    setWorking(isWork);
  };
  const travel = () => {
    setWorking(false);
  };
  const work = () => {
    setWorking(true);
  };
  const onChangeText = (payload) => setText(payload);
  const onChangeModifyText = (payload) => setModifyText(payload);
  const toggleModifly = (key) => {
    if (isModify) {
      setIsModify(false);
      modifyToDo(key);
    } else {
      setModifyText(toDos[key].text);
      setModifyKey(key);
      setIsModify(true);
    }
  };
  const addToDo = async () => {
    if (text === "") {
      return;
    }
    const newToDos = {
      ...toDos,
      [Date.now()]: { text, working: working, isDone: false },
    };
    setToDos(newToDos);
    await saveToDos(newToDos);
    setText("");
  };
  const deleteToDo = async (key) => {
    if (Platform.OS === "web") {
      const ok = confirm("Do you want to delete this To Do?");
      if (ok) {
        const newToDos = { ...toDos };
        delete newToDos[key];
        setToDos(newToDos);
        saveToDos(newToDos);
      }
    } else {
      Alert.alert("Delete To Do?", "Are you sure?", [
        { text: "Cancel" },
        {
          text: "I'm Sure",
          style: "destructive", // ios only
          onPress: () => {
            const newToDos = { ...toDos };
            delete newToDos[key];
            setToDos(newToDos);
            saveToDos(newToDos);
          },
        },
      ]);
    }
  };
  const modifyToDo = async (key) => {
    const newToDos = {
      ...toDos,
      [key]: { ...toDos[key], text: modifyText },
    };
    setToDos(newToDos);
    await saveToDos(newToDos);
    setIsModify(false);
    setModifyKey("");
  };
  const checkToDo = async (key) => {
    const newToDos = {
      ...toDos,
      [key]: { ...toDos[key], isDone: !toDos[key].isDone },
    };
    setToDos(newToDos);
    saveToDos(newToDos);
  };
  return (
    <View style={styles.container}>
      <StatusBar style="auto" />
      <View style={styles.header}>
        <TouchableOpacity onPress={work}>
          <Text
            style={{
              fontSize: 38,
              fontWeight: "600",
              color: working ? "white" : theme.grey,
            }}
          >
            Work
          </Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={travel}>
          <Text
            style={{
              fontSize: 38,
              fontWeight: "600",
              color: !working ? "white" : theme.grey,
            }}
          >
            Travel
          </Text>
        </TouchableOpacity>
      </View>
      <View>
        <TextInput
          onSubmitEditing={addToDo}
          onChangeText={onChangeText}
          returnKeyType="done"
          value={text}
          placeholder={working ? "Add a To Do" : "Where do you want to go?"}
          style={styles.input}
        ></TextInput>
      </View>
      <ScrollView>
        {toDos &&
          Object.keys(toDos).map((key) =>
            toDos[key].working === working ? (
              <View style={styles.toDo} key={key}>
                {toDos[key].isDone ? (
                  <Text style={{ ...styles.toDoText, ...styles.toDoTextDone }}>
                    {toDos[key].text}
                  </Text>
                ) : isModify && key === modifyKey ? (
                  <TextInput
                    onSubmitEditing={modifyToDo}
                    onChangeText={onChangeModifyText}
                    returnKeyType="modify"
                    value={modifyText}
                    placeholder={
                      working ? "Add a To Do" : "Where do you want to go?"
                    }
                    style={styles.input}
                  ></TextInput>
                ) : (
                  <Text style={styles.toDoText}>{toDos[key].text}</Text>
                )}

                <View style={styles.toDoTextBox}>
                  {!toDos[key].isDone && (
                    <TouchableOpacity
                      style={styles.toDoIcon}
                      onPress={() => toggleModifly(key)}
                    >
                      <Fontisto name="redo" size={18} color="white" />
                    </TouchableOpacity>
                  )}
                  <TouchableOpacity
                    style={styles.toDoIcon}
                    onPress={() => checkToDo(key)}
                  >
                    {toDos[key].isDone ? (
                      <Fontisto
                        name="checkbox-active"
                        size={18}
                        color="white"
                      />
                    ) : (
                      <Fontisto
                        name="checkbox-passive"
                        size={18}
                        color="white"
                      />
                    )}
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={styles.toDoIcon}
                    onPress={() => deleteToDo(key)}
                  >
                    <Fontisto name="trash" size={18} color="white" />
                  </TouchableOpacity>
                </View>
              </View>
            ) : null
          )}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.bg,
    paddingHorizontal: 20,
  },
  header: {
    justifyContent: "space-between",
    flexDirection: "row",
    marginTop: 100,
  },
  input: {
    backgroundColor: "white",
    paddingVertical: 15,
    paddingHorizontal: 20,
    borderRadius: 30,
    marginVertical: 20,
    fontSize: 18,
  },
  toDo: {
    backgroundColor: theme.grey,
    marginBottom: 10,
    paddingVertical: 20,
    paddingHorizontal: 20,
    borderRadius: 15,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  toDoTextBox: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  toDoText: {
    color: "white",
    fontSize: 16,
    fontWeight: "500",
  },
  toDoIcon: {
    marginHorizontal: 10,
  },
  toDoTextDone: {
    color: "darkgrey",
    textDecorationLine: "line-through",
  },
});
